<template lang="pug">
v-dialog(v-model="showBillingDetailDialog" :fullscreen="$vuetify.breakpoint.mdAndDown" max-width="700" persistent scrollable)
    v-snackbar( v-model="snackBar" :color="snackBarColor" ) {{ snackBarMessage }}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="snackBar = false") {{ $t('buttons.closeButtonLabel') }}
    v-card
        v-card-title {{ invoice.name }}
        v-tabs(v-model="tab")
            v-tab {{ $t('billingDetailDialog.informationTabTitle') }}
            v-tab {{ $t('billingDetailDialog.paymentsTabTitle') }}
        v-card-text(style="height: 50vh;")
          v-tabs-items(v-model="tab")
            v-tab-item
                v-card(flat)
                    v-card-text
                        v-col(cols="12")
                            v-row.ma-0
                                v-col.d-flex.justify-space-around(cols="6")
                                    v-card(width="250")
                                        v-card-title {{ $t('billingDetailDialog.notPayedWidgetTitleLabel') }}
                                        v-card-subtitle
                                        v-col.text-h3
                                            v-row.pa-4
                                                v-spacer
                                                div.pb-0.pr-1.font-weight-bold {{ invoice.formattedPriceTotal }} €
                                v-col.d-flex.justify-space-around(cols="6")
                                    v-card(width="250")
                                        v-card-title {{ $t('billingDetailDialog.payedWidgetTitleLabel') }}
                                        v-card-subtitle
                                        v-col.text-h3
                                            v-row.pa-4
                                                v-spacer
                                                div.pb-0.pr-1.font-weight-bold {{ invoice.formattedAmountAlreadyPaid }} €
                            v-row
                                v-col(cols="6")
                                    v-list.text-body-1.pl-3
                                        v-list-item {{ $t('billingDetailDialog.nameListItemTitle') }}
                                            v-list-item-content.font-weight-black.pl-2 {{ invoice.boarder.person.fullName }}
                                        v-list-item {{ $t('billingDetailDialog.periodListItemTitle') }}
                                            v-list-item-content.font-weight-black.pl-2 {{ invoice.formattedPeriodRange }}
                                        v-list-item {{ $t('billingDetailDialog.foodPriceListItemTitle') }}
                                            v-list-item-content.font-weight-black.pl-2 {{ invoice.formattedPriceItemSum }} &euro;
                                v-col(cols="6")
                                    v-list.text-body-1.pl-3
                                        v-list-item {{ $t('billingDetailDialog.payedWithCreditListItemTitle') }}
                                            v-list-item-content.font-weight-black.pl-2 {{ invoice.formattedAmountFromWallet }} &euro;
                                        v-list-item {{ $t('billingDetailDialog.arrearsListItemTitle') }}
                                            v-list-item-content.font-weight-black.pl-2 {{ invoice.formattedAmountFromDept }} &euro;
                            v-row
                                v-btn.ml-10( color="primary" @click="onDownloadInvoiceButtonClick") {{ $t('billingDetailDialog.downloadInvoiceButtonLabel') }}
            v-tab-item
                v-data-table(
                  v-if="invoiceData && invoiceData.invoicePayments.length > 0"
                  :headers="headers"
                  :items="invoiceData.invoicePayments"
                  hide-default-footer )
                    template(v-slot:item.sourceKind="{ item }")
                        div {{getKind(item.sourceKind)}}
                    template(v-slot:item.createdAt="{ item }")
                      div {{getDate(item.createdAt)}}
                    template(v-slot:item.paymentsFromTransaction="{ item }")
                      div {{getDatePosted(item)}}
                    template(v-slot:item.amount="{ item }")
                      div {{getAmount(item.amount)}} €
                v-row(v-if="!invoiceData || (invoiceData && invoiceData.invoicePayments.length === 0)")
                    v-col.title.text-center(cols="12") {{ $t('billingErrorMessage') }}
        v-divider
        v-card-actions
            v-spacer
            v-btn( @click="onCloseButtonClick" text color="primary" ) {{ $t('buttons.closeButtonLabel') }}
</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {Invoice} from '@/model/billing/Invoice'
import {Action} from "vuex-class";
import {DOWNLOAD_INVOICE, FETCH_INVOICE} from "@/store/action-types";
import moment from "moment";
import i18n from "@/plugins/i18n";
import {formatIntPrice} from "@/services/formatter";

@Component({
  components: {}
})
export default class BillingDetailDialog extends Vue {
  @Prop({type: Boolean, default: false}) showBillingDetailDialog!: boolean
  @Prop({type: Object as () => Invoice}) invoice!: Invoice
  @Action(FETCH_INVOICE) fetchInvoice!: { (payload: any): Promise<Invoice> }
  @Action(DOWNLOAD_INVOICE) downloadInvoice!: { (payload: Invoice): Promise<void> }

  private invoiceData: Invoice | null = null
  private tab: number = 0
  private headers: any[] = [
    {text: i18n.t('sourceKind').toString(), align: 'start',sortable: false, value: 'sourceKind'},
    {text: i18n.t('posted').toString(), value: 'paymentsFromTransaction' },
    {text: i18n.t('bankTransactionPage.dateAvailable').toString(), value: 'createdAt'},
    {text: i18n.t('amount').toString(), value: 'amount'}
  ]

  private snackBar: boolean = false
  private snackBarMessage: string = ''
  private snackBarColor: string = ''

  getDate (item: any) {
    return moment(item,'YYYY-MM-DD').format('D.M.YYYY')
  }

  getDatePosted (item: any) {
    if(item.paymentsFromTransaction.length > 0) {
      return moment(item.paymentsFromTransaction[0].datePosted,'YYYY-MM-DD').format('D.M.YYYY')
    } else {
      return moment(item.paymentsFromWallet[0].createdAt,'YYYY-MM-DD').format('D.M.YYYY')
    }

  }

  getAmount (item: any) {
    return formatIntPrice(item)
  }

  getKind (item: any) {
    if(item === 'bank_transfer') {
      return this.$t('billingDetailDialog.bankTransfer').toString()
    } else {
      return this.$t('billingDetailDialog.credit').toString()
    }
  }

  onCloseButtonClick(): void {
    this.closeDialog()
  }

  closeDialog(): void {
    this.$emit('closeDialog')
  }

  async fetchInvoiceData () {
    const payload: any = this.invoice.id
    try{
      this.invoiceData = await this.fetchInvoice(payload)
    } catch (e) {

    }
  }

  async onDownloadInvoiceButtonClick(): Promise<void> {
      try {
        // this.currentInvoiceToDownload = invoice
        await this.downloadInvoice(this.invoice)
      } catch (e) {
        this.snackBar = true
        this.snackBarMessage = this.$t('errors.downloadingErrorMessage').toString()
        this.snackBarColor = 'alert'
      } finally {
        // this.currentInvoiceToDownload = null
      }
  }

  mounted (): void {
    this.fetchInvoiceData()
  }
}
</script>

<style lang="stylus" scoped>

</style>